var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { t } from 'i18next';
import { getApi } from '../../utils/fetcher';
import { BaseComponent } from '../../utils/BaseComponent';
import { SettingsController } from '../../utils/SettingsController';
import '../../components/tabs/tabPanel';
import '../../components/experimentation/experiment';
import './components/ListItem';
import { isExpired } from '../../utils/date';
import { NoFeedback } from './components/NoFeedbacks';
let PrivateListing = class PrivateListing extends BaseComponent {
    constructor() {
        super();
        this._settingListener = new SettingsController(this, this.getData.bind(this));
        this.user = t('Anonymous user');
        this.giveFeedbackUrl = '.';
        this.profileUrl = '.';
        this._refreshData = this._refreshData.bind(this);
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('update', this._refreshData);
    }
    _refreshData(e) {
        this.getData();
        e.preventDefault();
        e.stopPropagation();
    }
    disconnectedCallback() {
        window.removeEventListener('update', this._refreshData);
        super.disconnectedCallback();
    }
    willUpdate(_changedProperties) {
        if (_changedProperties.has('user')) {
            this.getData();
        }
    }
    async getData() {
        if (window.trustSettings) {
            const url = '/trades/search/active-or-closed-trades';
            const { data: feedbacks } = await getApi(url, window.trustSettings, this.overrideAccessToken) || {};
            const sortedFeedbacks = feedbacks === null || feedbacks === void 0 ? void 0 : feedbacks.sort((a, b) => new Date(b.completedAt).getTime() - new Date(a.completedAt).getTime());
            this.privateListings = sortedFeedbacks;
        }
    }
    render() {
        if (!window.trustSettings || !this.privateListings)
            return nothing;
        if (this._error)
            return html `
      <trust-error
        .error=${true}
        @retry='${() => { this._error = undefined; this.getData(); }}'>
      </trust-error>
    `;
        const privateListingHTML = (privateListing, me, other, otherPersonProfileUrl, feedbackGiven) => {
            if (me.hasGivenFeedback || isExpired(new Date(privateListing.expiryDate))) {
                return html `
                  <li class="bg-surface-secondary p-16 rounded-8">
                    <trust-private-listing-list-item
                            .privateListing=${privateListing}
                            .me=${me}
                            .other=${other}
                            ?feedbackGiven=${feedbackGiven}
                            profileUrl=${otherPersonProfileUrl}
                    ></trust-private-listing-list-item>
                  </li>`;
            }
            else {
                return html `
                  <li class='yellow-bg rounded-8 p-16'>
                    <trust-private-listing-list-item
                            .privateListing=${privateListing}
                            .me=${me}
                            .other=${other}
                            ?feedbackGiven=${feedbackGiven}
                            profileUrl=${otherPersonProfileUrl}
                            giveFeedbackUrl=${this.giveFeedbackUrl}
                    ></trust-private-listing-list-item>
                </li>`;
            }
        };
        const privateListings = (feedbackGiven) => {
            var _a, _b;
            if (((_a = this.privateListings) === null || _a === void 0 ? void 0 : _a.length) === 0)
                return NoFeedback({ isMobile: this.screen.isMobile, feedbackReceived: feedbackGiven });
            return html `
        <ul class='list-none flex flex-col gap-16 p-0 max-w-[600px]'>
          ${(_b = this.privateListings) === null || _b === void 0 ? void 0 : _b.map(privateListing => {
                const me = privateListing.participants.find(participant => participant.isCurrentUser);
                const other = privateListing.participants.find(participant => !participant.isCurrentUser);
                const otherPersonProfileUrl = this.profileUrl && other ? this.profileUrl.replace('{{userId}}', other.localProfileId) : undefined;
                return privateListingHTML(privateListing, me, other, otherPersonProfileUrl, feedbackGiven);
            })}
        </ul>
      `;
        };
        return html `
      <trust-tab-panel index=0 key=${this.tabKey}>
        ${privateListings(false)}
      </trust-tab-panel>
      <trust-tab-panel index=1 key=${this.tabKey}>
        ${privateListings(true)}
      </trust-tab-panel>
    `;
    }
};
__decorate([
    property({ type: String })
], PrivateListing.prototype, "overrideAccessToken", void 0);
__decorate([
    state()
], PrivateListing.prototype, "privateListings", void 0);
__decorate([
    property({ type: String })
], PrivateListing.prototype, "user", void 0);
__decorate([
    property()
], PrivateListing.prototype, "tabKey", void 0);
__decorate([
    property()
], PrivateListing.prototype, "giveFeedbackUrl", void 0);
__decorate([
    property()
], PrivateListing.prototype, "profileUrl", void 0);
PrivateListing = __decorate([
    customElement('trust-private-listing')
], PrivateListing);
export { PrivateListing };
//# sourceMappingURL=PrivateListing.js.map